<template>
  <div class="solvents">
    <div class="card" v-for="data in datas" :key="data.title" @mouseenter="mouseover(data.imgSrcDetail)">
      <!-- <img class="img" :src="data.src" /> -->
      <div class="info">
        <p class="title">
          <span class="text-title">{{ data.title }}</span>
        </p>
        <p class="intro">{{ data.intro }}</p>
        <!-- <div class="btn" @click="showDetailed(data.imgSrcDetail)">Detailed</div> -->
        <!-- <div class="btn" @mouseenter="mouseover(data.imgSrcDetail)">
          Detailed
        </div> -->
      </div>
    </div>
    <el-drawer
      title="我是标题"
      :visible="visible"
      :with-header="false"
      @close="closed"
      size="60%"
    >
      <!-- <img :src="imgDetails[currentSrcStr]" alt="currentSrc" style="width: 700px"/> -->
      <components :is="currentSrcStr" />
    </el-drawer>
  </div>
</template>

<script>
// import ACTdetail from "./imgs/ACTdetail.png";
// import IPAdetail from "./imgs/IPAdetail.png";
// import MTACdetail from "./imgs/MTACdetail.png";
// import ETACdetail from "./imgs/ETACdetail.png";
// import NBACdetail from "./imgs/NBACdetail.png";
// import DEGdetail from "./imgs/DEGdetail.png";
// import TEGdetail from "./imgs/TEGdetail.png";
// import MPGdetail from "./imgs/MPGdetail.png";
// import MEKdetail from "./imgs/MEKdetail.png";
// import PCEdetail from "./imgs/PCEdetail.png";
// import TCEdetail from "./imgs/TCEdetail.png";
// import THFdetail from "./imgs/THFdetail.png";

import ACTdetail from "./ACTdetail.vue";
import IPAdetail from "./IPAdetail.vue";
import MTACdetail from "./MTACdetail.vue";
import ETACdetail from "./ETACdetail.vue";
import NBACdetail from "./NBACdetail.vue";
import DEGdetail from "./DEGdetail.vue";
import TEGdetail from "./TEGdetail.vue";
import MPGdetail from "./MPGdetail.vue";
import MEKdetail from "./MEKdetail.vue";
import PCEdetail from "./PCEdetail.vue";
import TCEdetail from "./TCEdetail.vue";
import THFdetail from "./THFdetail.vue";

import { debounce } from "lodash";

export default {
  name: "Solvents",
  components: {
    ACTdetail,
    IPAdetail,
    MTACdetail,
    ETACdetail,
    NBACdetail,
    DEGdetail,
    TEGdetail,
    MPGdetail,
    MEKdetail,
    PCEdetail,
    TCEdetail,
    THFdetail,
  },
  data() {
    return {
      visible: false,
      currentSrcStr: "ACTdetail",
      // imgDetails: {
      //   ACTdetail,
      //   IPAdetail,
      //   MTACdetail,
      //   ETACdetail,
      //   NBACdetail,
      //   DEGdetail,
      //   TEGdetail,
      //   MPGdetail,
      //   MEKdetail,
      //   PCEdetail,
      //   TCEdetail,
      //   THFdetail,
      // },
      datas: [
        {
          title: "Acetone(ACT)",
          intro: "Molecular Formula: C3H6O CAS No.: 67-64-1",
          imgSrcDetail: "ACTdetail",
        },
        {
          title: "Isopropyl Alcohol（IPA）",
          intro: "CAS NO.: 67-63-0",
          imgSrcDetail: "IPAdetail",
        },
        {
          title: "Methyl Acetate （MTAC）",
          intro: "MTAC NO.: 79-20-9",
          imgSrcDetail: "MTACdetail",
        },
        {
          title: "Ethyl Acetate (ETAC)",
          intro: "CAS NO.: 141-78-6",
          imgSrcDetail: "ETACdetail",
        },
        {
          title: "N-Butyl Acetate （NBAC）",
          intro: "CAS NO.: 123-86-4",
          imgSrcDetail: "NBACdetail",
        },
        {
          title: "Diethylene Glycol (DEG)",
          intro: "CAS NO.: 111-46-6",
          imgSrcDetail: "DEGdetail",
        },
        {
          title: "Triethylene glycol(TEG)",
          intro: "CAS NO.: 112-27-6",
          imgSrcDetail: "TEGdetail",
        },
        {
          title: "Propylene Glycol(MPG)",
          intro: "CAS NO. : 57-55-6",
          imgSrcDetail: "MPGdetail",
        },
        {
          title: "Methyl Ethyl Ketone（MEK）",
          intro: "CAS No.: 78-93-3",
          imgSrcDetail: "MEKdetail",
        },
        {
          title: "Perchloroethylene（PCE）",
          intro: "CAS NO.: 127-18-4",
          imgSrcDetail: "PCEdetail",
        },
        {
          title: "Trichloroethylene(TCE)",
          intro: "CAS NO.: 79-01-6",
          imgSrcDetail: "TCEdetail",
        },

        {
          title: "Tetrahydrofuran(THF)",
          intro: "CAS NO.: 109-99-9",
          imgSrcDetail: "THFdetail",
        },
      ],
    };
  },
  methods: {
    showDetailed(imgSrcDetail) {
      this.currentSrcStr = imgSrcDetail;
      this.visible = true;
    },
    mouseover(imgSrcDetail) {
      this.currentSrcStr = imgSrcDetail;
      this.visible = true;
    },
    closed() {
      this.visible = false;
    },
  },
  mounted() {
    this.mouseover = debounce(this.mouseover, 700);
  },
};
</script>

<style lang="less" scoped>
.solvents {
  .card {
    display: flex;
    background-color: #fff;
    margin-bottom: 20px;
    padding-bottom: 20px;
    cursor: pointer;
    border-radius: 10px;
    // .img {
    //   display: block;
    //   position: relative;
    //   z-index: 2;
    //   width: 260px;
    //   border-right: solid 1px #ddd;
    // }
    .title {
      padding-left: 30px;
      line-height: 60px;
    }
    .text-title {
      font-size: 26px;
      color: #333;
    }
    &:hover {
      .text-title {
        animation: text-title 1s linear;
        animation-name: text-title;
        animation-delay: 0s;
        animation-timing-function: linear;
        animation-duration: 0.7s;
      }
    }
    @keyframes text-title {
      0% {
        margin-left: 0;
      } 
      50% {
        margin-left: 50px;
        color: rgba(8, 84, 132, 1);
      }
      100% {
        margin-left: 0;
      }
    }
    .info {
      height: 150px;
      position: relative;
      z-index: 1;
      width: 100%;
      &:hover {
        .btn {
          background-color: rgba(8, 84, 132, 1);
          transform: scale(1.2);
        }
      }
      .intro {
        font-size: 18px;
        color: #777;
        padding-left: 30px;
      }
      .btn {
        cursor: pointer;
        margin-left: 30px;
        margin-top: 20px;
        margin-bottom: 20px;
        width: 150px;
        line-height: 40px;
        text-align: center;
        color: #fff;
        background-color: rgba(8, 84, 132, 0.7);
        transition: transform 0.8s linear;
      }
    }
  }
}
</style>
